<script setup>
  import {ref} from "vue";

  defineOptions({
    name: "ComponentToastMessage",
  });

  const toasts = ref([]);

  const bgColor = (type = "info") => {
    const colors = {
      success: "bg-mcgreen-100 border-mcgreen text-mcgreen-900",
      warning: "bg-orange-100 border-orange-400 text-orange-900",
      error: "bg-mcred-100 border-mcred text-mcred-900",
      info: "bg-blue-100 border-blue-600 text-blue-900",
    };

    return colors[type];
  };

  const addToastMessage = (message, type, duration) => {
    const toast = {id: Date.now(), message, type: type};
    toasts.value.push(toast);

    setTimeout(() => {
      removeToast(toast.id);
    }, duration);

    if (toasts.value.length > 5) {
      toasts.value.shift();
    }
  };

  const removeToast = (id) => {
    toasts.value = toasts.value.filter((toast) => toast.id !== id);
  };

  defineExpose({
    addToastMessage,
  });
</script>

<template>
  <ul class="fixed right-5 bottom-16 z-30 flex max-w-96 flex-col space-y-2">
    <TransitionGroup name="fade">
      <li
        v-for="toast in toasts"
        :key="toast.id"
        class="animate-fade-in-up self-end border-l-4 p-2 shadow-md"
        :class="`${bgColor(toast.type)}`"
        :data-test="getTestId(`toast-message-${toast.type}-${toast.id}`)"
      >
        {{ toast.message }}
      </li>
    </TransitionGroup>
  </ul>
</template>

<style scoped>
  .fade-leave-active {
    transition:
      transform 0.5s ease-out,
      opacity 0.5s;
  }

  .fade-leave-to {
    opacity: 0;
    transform: translateY(-30px);
  }
</style>
